import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const KioskPinCard = () => {
  const [hasPin, setHasPin] = useState(false);
  const [pin, setPin] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    api.get("/kiosk/pin-status").then((r) => setHasPin(r.data.has_pin)).catch(() => {});
  }, []);

  const save = async (value) => {
    try {
      const r = await api.put("/kiosk/pin", { pin: value, password });
      setHasPin(r.data.has_pin);
      setPin("");
      setPassword("");
      toast.success(r.data.has_pin ? "Kiosk PIN'i kaydedildi" : "Kiosk PIN'i kaldırıldı");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kaydedilemedi");
    }
  };

  const input = "w-full border border-[var(--fb-border)] rounded-xl px-3 py-2.5 text-sm";
  return (
    <div data-testid="kiosk-pin-card" className="bg-white border border-[var(--fb-border)] rounded-2xl p-5 mb-6">
      <div className="flex items-center gap-2 mb-1">
        <Lock className="w-5 h-5 text-[var(--fb-red)]" />
        <h3 className="font-display font-bold text-lg">Kiosk Yönetim PIN'i</h3>
        <span data-testid="kiosk-pin-status" className={`ml-auto text-xs font-bold px-2.5 py-1 rounded-full ${hasPin ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
          {hasPin ? "Aktif" : "Belirlenmedi"}
        </span>
      </div>
      <p className="text-sm text-[var(--fb-muted)] mb-4">Kioskta logoya 10 kez dokunulunca panel açılmadan önce bu 4 haneli PIN sorulur.</p>
      <div className="grid sm:grid-cols-3 gap-3">
        <input data-testid="kiosk-pin-input" inputMode="numeric" maxLength={4} placeholder="Yeni PIN (4 rakam)" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))} className={input} />
        <input data-testid="kiosk-pin-password" type="password" placeholder="Hesap şifreniz" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
        <button data-testid="kiosk-pin-save" onClick={() => save(pin)} disabled={pin.length !== 4 || !password} className="bg-[var(--fb-red)] disabled:opacity-40 text-white font-semibold rounded-full px-5 py-2.5">
          PIN'i Kaydet
        </button>
      </div>
      {hasPin && (
        <button data-testid="kiosk-pin-remove" onClick={() => save("")} disabled={!password} className="mt-3 text-sm font-semibold text-[var(--fb-muted)] hover:text-[var(--fb-red)] disabled:opacity-40">
          PIN'i kaldır (hesap şifresi gerekli)
        </button>
      )}
    </div>
  );
};
